import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { fetchContactInfo } from "../lib/api";

const SAFE_CODE = /^[A-Za-z0-9_\-.=]{1,120}$/;

export default function GoogleSiteVerification() {
  const [code, setCode] = useState("");

  useEffect(() => {
    fetchContactInfo()
      .then((c) => setCode((c.google_site_verification || "").trim()))
      .catch(() => {});
  }, []);

  if (!code || !SAFE_CODE.test(code)) return null;
  return (
    <Helmet>
      <meta name="google-site-verification" content={code} />
    </Helmet>
  );
}
